export const ADMIN_EVENT = "admin-event"



// WEBPACK FOOTER //
// ./src/types/pubsub.js